// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1ERV_","errors":"Errors_errors__2vMH2"};